import React from 'react';
import styled from 'styled-components';

const B5Style = styled.svg``;

export const B5 = ({ color }) => {
	return (
		<B5Style
			xmlns='http://www.w3.org/2000/svg'
			width='21.771'
			height='22.213'
			viewBox='0 0 21.771 22.213'
		>
			<path
				id='PIano'
				d='M958.867,484.635a.858.858,0,0,1-.857.857H937.959a.863.863,0,0,1-.863-.857V469.207c0-7.9,11.976-7.9,11.976,0a2.263,2.263,0,0,0,2.17,2.5h1.629a6.022,6.022,0,0,1,6,5.988v6.937Zm-20.059-5.46h18.345V477.7a4.3,4.3,0,0,0-4.283-4.274h-1.629a3.959,3.959,0,0,1-3.876-4.217c0-5.642-8.556-5.648-8.556,0v9.968Zm18.345,1.027h-1.075v1.583a.511.511,0,1,1-1.021,0V480.2h-.875v1.583a.511.511,0,1,1-1.021,0V480.2h-2.77v1.583a.514.514,0,0,1-1.028,0V480.2H948.5v1.583a.515.515,0,0,1-.517.513.51.51,0,0,1-.511-.513V480.2H946.6v1.583a.516.516,0,0,1-1.033,0V480.2h-2.758v1.583a.516.516,0,0,1-1.033,0V480.2h-.863v1.583a.516.516,0,0,1-1.033,0V480.2h-1.071v3.576h18.345V480.2Z'
				transform='translate(-937.096 -463.279)'
				fill={color}
			/>
		</B5Style>
	);
};
